'use client';

import { useEffect, useState } from 'react';

/**
 * 상단 GNB(`<header>`) 높이를 ResizeObserver로 추적.
 * 바텀시트 snap 계산, 지도 액션 버튼 오프셋 등 레이아웃 공유용.
 * 부수 효과로 --header-height CSS 변수를 최신 상태로 유지한다.
 */
export function useHeaderHeight(): number {
  const [height, setHeight] = useState(0);

  useEffect(() => {
    const header = document.querySelector('header');
    if (!header) return;
    const measure = () => {
      const h = header.offsetHeight;
      setHeight(h);
      document.documentElement.style.setProperty('--header-height', `${h}px`);
    };
    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(header);
    return () => observer.disconnect();
  }, []);

  return height;
}
